const parentFolder = 'animation/ec/a1/'
export default {
  v: '5.9.0',
  fr: 29.9700012207031,
  ip: 0,
  op: 276.00001124171,
  w: 850,
  h: 700,
  nm: 'Animacion-premios',
  ddd: 0,
  assets: [
    { id: 'image_0', w: 610, h: 188, u: parentFolder, p: 'img_0.png', e: 0 },
    { id: 'image_1', w: 610, h: 188, u: parentFolder, p: 'img_1.png', e: 0 },
    { id: 'image_2', w: 487, h: 245, u: parentFolder, p: 'img_2.png', e: 0 },
    { id: 'image_3', w: 466, h: 290, u: parentFolder, p: 'img_3.png', e: 0 },
    { id: 'image_4', w: 914, h: 758, u: parentFolder, p: 'img_4.png', e: 0 },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 2,
      nm: 'TOP 4 AL 10 FRASE',
      refId: 'image_0',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [445, 297.5, 0], ix: 2, l: 2 },
        a: { a: 0, k: [301, 204, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.316, 0.316, 0.667], y: [1, 1, 1] },
              o: { x: [0.785, 0.785, 0.333], y: [0, 0, 0] },
              t: 157,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.281, 0.281, 0.667], y: [1, 1, 1] },
              o: { x: [0.83, 0.83, 0.333], y: [0, 0, 0] },
              t: 173,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 189,
              s: [100, 100, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 265,
              s: [100, 100, 100],
            },
            { t: 274.000011160249, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 133.000005417201,
      op: 1634.00006655418,
      st: 133.000005417201,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 2,
      nm: 'TOP 4 AL 10',
      refId: 'image_1',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [441.5, 291.5, 0], ix: 2, l: 2 },
        a: { a: 0, k: [307, 208, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.316, 0.316, 0.667], y: [1, 1, 1] },
              o: { x: [0.785, 0.785, 0.333], y: [0, 0, 0] },
              t: 21,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.281, 0.281, 0.667], y: [1, 1, 1] },
              o: { x: [0.83, 0.83, 0.333], y: [0, 0, 0] },
              t: 37,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 53,
              s: [100, 100, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 138,
              s: [100, 100, 100],
            },
            { t: 147.000005987433, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 1501.00006113698,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 2,
      nm: 'TOP 1 AL 3 FRASE',
      refId: 'image_2',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [431.5, 530.5, 0], ix: 2, l: 2 },
        a: { a: 0, k: [243.5, 251.564, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.418, 0.418, 0.667], y: [1, 1, 1] },
              o: { x: [0.615, 0.615, 0.333], y: [0, 0, 0] },
              t: 146,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.406, 0.406, 0.667], y: [1, 1, 1] },
              o: { x: [0.629, 0.629, 0.333], y: [0, 0, 0] },
              t: 167,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 187,
              s: [100, 100, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 263,
              s: [100, 100, 100],
            },
            { t: 276.00001124171, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 146.000005946702,
      op: 1647.00006708369,
      st: 146.000005946702,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 2,
      nm: 'TOP 1 AL 3',
      refId: 'image_3',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [421.5, 530.5, 0], ix: 2, l: 2 },
        a: { a: 0, k: [241.393, 257.009, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.418, 0.418, 0.667], y: [1, 1, 1] },
              o: { x: [0.615, 0.615, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.406, 0.406, 0.667], y: [1, 1, 1] },
              o: { x: [0.629, 0.629, 0.333], y: [0, 0, 0] },
              t: 21,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 41,
              s: [100, 100, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 135,
              s: [100, 100, 100],
            },
            { t: 148.000006028164, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 1501.00006113698,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 2,
      nm: 'Base premios',
      refId: 'image_4',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [437, 334, 0], ix: 2, l: 2 },
        a: { a: 0, k: [457, 379, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 1501.00006113698,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
}
